import type { DateRange } from './types';

export function lastNDays(n: number): DateRange {
  const to = new Date();
  const from = new Date(to.getTime() - n * 86_400_000);
  return { from: from.toISOString(), to: to.toISOString() };
}

export const RANGE_PRESETS: ReadonlyArray<{ label: string; days: number }> = [
  { label: 'Last 7 days', days: 7 },
  { label: 'Last 30 days', days: 30 },
  { label: 'Last 90 days', days: 90 },
];

export const DEFAULT_RANGE_DAYS = 30;
